import { styled } from '@mui/material/styles';
import { AppBar } from '@mui/material';
import { getThemeColor } from '../../../utils/styleUtils';

export const StyledNavBar = styled(AppBar)(({ backgroundColor, theme }) => ({
  ...(backgroundColor
    ? { backgroundColor: getThemeColor(backgroundColor, theme) }
    : {}),
}));

export const NavebarButtonsStyles = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const DesktopContainer = {
  flexGrow: 1,
  display: { xs: 'none', lg: 'flex' },
  justifyContent: 'flex-end',
  gap: '50px',
  mr: '20px',
};

export const MobileContainer = {
  flexGrow: 1,
  display: { xs: 'flex', lg: 'none' },
  justifyContent: 'space-between',
  alignItems: 'center',
};
